// frontend/src/marketing/pages/legal/AupPage.tsx
import * as React from 'react';
import { LegalPageLayout, type LegalSection } from './LegalPageLayout';

const SECTIONS: LegalSection[] = [
  {
    heading: 'The short version',
    body: (
      <p>
        Use Worqly to run a real business. Don't use it to harm people, break the law, or abuse the
        platform. We may suspend workspaces that do.
      </p>
    ),
  },
  {
    heading: 'Prohibited content',
    body: (
      <p>
        No content that is illegal, infringes intellectual-property rights, contains malware, or
        constitutes fraudulent business documents (e.g. fake invoices intended to deceive a third
        party into paying money not owed).
      </p>
    ),
  },
  {
    heading: 'Prohibited behavior',
    body: (
      <>
        <p>
          No attempts to access other workspaces' data, probe or overload the Service, bypass rate
          limits or captcha, resell access without an agreement, or use the platform to send spam.
        </p>
        <p>
          The monitoring module may only be used on devices of employees who have been informed in
          accordance with applicable law. Covert monitoring of individuals is prohibited.
        </p>
      </>
    ),
  },
  {
    heading: 'Security research',
    body: (
      <p>
        Good-faith security research against your own workspace is welcome — see the{' '}
        <a className="underline underline-offset-2" href="/security">security page</a> for how to
        report findings. Testing against other customers' workspaces is never permitted.
      </p>
    ),
  },
  {
    heading: 'Enforcement',
    body: (
      <p>
        Violations may lead to content removal, workspace suspension, or termination depending on
        severity. Where lawful, we'll notify the workspace owner and give a chance to remediate
        before acting, except for ongoing abuse, security threats, or legal requirements.
      </p>
    ),
  },
];

export function AupPage() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Acceptable use policy"
      description="What you may and may not do on the Worqly platform."
      updated="June 4, 2026"
      sections={SECTIONS}
    />
  );
}
